import { useMemo } from 'react';
import type { RSPageModelBase, RSPageUiPreferences } from '../api/api.types';

export function getPageUiPreferences(
  pageModel: RSPageModelBase | null | undefined,
): RSPageUiPreferences {
  return pageModel?.ui_preferences ?? {};
}

export function getPageUiPreferenceInverted(
  pageModel: RSPageModelBase | null | undefined,
): boolean {
  return !!getPageUiPreferences(pageModel).inverted_status;
}

/** Reads `ui_preferences` from any FundPage / OverviewPage envelope. */
export function usePageUiPreferences(
  pageModel: RSPageModelBase | null | undefined,
): RSPageUiPreferences & { inverted_status: boolean } {
  return useMemo(() => {
    const prefs = getPageUiPreferences(pageModel);
    return {
      ...prefs,
      inverted_status: !!prefs.inverted_status,
    };
  }, [pageModel]);
}
